import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserWaiterMemoryGame from 'src/games/WaiterMemoryGame/Main';

interface WaiterMemoryGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class WaiterMemoryGame extends React.Component<WaiterMemoryGameProps> {
    constructor(props: WaiterMemoryGameProps) {
        super(props);
        bindAllOfThis(this, WaiterMemoryGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserWaiterMemoryGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default WaiterMemoryGame;



// WEBPACK FOOTER //
// ./src/pages/game/WaiterMemoryGame.tsx